module.exports = __webpack_public_path__ + "static/img/8.e8e211d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/8.jpg
// module id = URVa
// module chunks = 36